import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { SERVICES } from '../mock';

export default function ServicesGrid({ excludeId }) {
  const items = SERVICES.filter((s) => s.id !== excludeId);
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      {items.map((s, i) => (
        <Link
          key={s.id}
          to={s.href}
          className="card-glow group relative overflow-hidden rounded-2xl border border-white/8 bg-[#0e0e0c]"
          style={{ animationDelay: `${i * 80}ms` }}
        >
          <div className="relative h-64 overflow-hidden">
            <img
              src={s.image}
              alt={s.title}
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0e0e0c] via-[#0e0e0c]/30 to-transparent" />
          </div>
          <div className="p-7">
            <h3 className="font-serif-display text-2xl md:text-[26px] text-[#f5efe3] group-hover:text-[#e8d5a8] transition-colors leading-snug">
              {s.title}
            </h3>
            <p className="mt-3 text-sm text-[#9a9285] leading-relaxed line-clamp-3">{s.excerpt}</p>
            <div className="mt-6 inline-flex items-center gap-2 text-sm text-[#d4b574] group-hover:gap-3 transition-all">
              Mehr dazu <ArrowRight size={14} />
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
}
